import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=61ef0d8e&scoped=true"
import script from "./EditCompany.vue?vue&type=script&lang=js"
export * from "./EditCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef0d8e",
  null
  
)

export default component.exports